import { render, staticRenderFns } from "./CustomLoadingAnimation.vue?vue&type=template&id=134498fe&scoped=true&"
import script from "./CustomLoadingAnimation.vue?vue&type=script&lang=js&"
export * from "./CustomLoadingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./CustomLoadingAnimation.vue?vue&type=style&index=0&id=134498fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134498fe",
  null
  
)

export default component.exports